export const TEMP_UID_KEY = 'temp-';
